'use client';

import
  dynamic
from 'next/dynamic';

import
  SectionLayout
from '@/app/ui/section-layout';

import
  FeatureCard
from '@/app/ui/features/feature-card';

import {
  features
} from '@/app/data/features';

import {
  useScrollReveal
} from '@/app/hooks/use-scroll-reveal';

// Fetched at runtime by LottiePlayer, not bundled into JS.
const plugAnim = '/lottie/plug-feature-animation.json';

const LottiePlayer = dynamic(() => import('@repo/ui/lottie-player'), {
  ssr: false
});

export default function FeaturesSection() {

  const {
    ref, isVisible
  } = useScrollReveal<HTMLDivElement>();

  return (
    <SectionLayout
      label="Features"
      heading="Elite Scholars features personalized tutoring sessions designed to meet the unique needs and learning styles of each student."
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 mb-16">
        {features.map((feature) => (
          <FeatureCard key={feature.title} {...feature} />
        ))}
      </div>

      <div className="flex justify-center">
        <div ref={ref} className="w-48 h-48">
          {isVisible && <LottiePlayer animationPath={plugAnim} className="w-full h-full" />}
        </div>
      </div>
    </SectionLayout>
  );
}
